var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7659 2.55231L19.7591 2.51115L14.9014 7.40994L16.6304 9.13892L21.5292 4.24013L21.488 8.27443H23.958L24.0403 0L15.7659 0.0823329V2.55231Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.27443 21.4891H4.2813L9.13892 16.6315L7.40994 14.8613L2.51115 19.7601L2.55231 15.767L0.0823329 15.7258L0 24.0002L8.27443 23.9591V21.4891Z",
    fill: "#3BBEE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expandIcon.c70b74b71a8dfd928daa00a99ce461e1.svg";
export { ForwardRef as ReactComponent };